import http from 'hub-http/clients/apiClient';
import { IDENTIFICATION_TOKEN } from '../constants/EarlyRequesterNames';
import getEarlyRequesterResult from './getEarlyRequesterResult';
const ENDPOINT = 'helpdesk-integration/v1/messages/tokens/create';
export const getIdentificationToken = () => {
  const earlyRequest = getEarlyRequesterResult(IDENTIFICATION_TOKEN);
  const earlyRequestWithRetry = earlyRequest ? earlyRequest.catch(() => http.post(ENDPOINT)) : null;
  return earlyRequestWithRetry || http.post(ENDPOINT);
};